import { createAction } from 'redux-actions';

export const allRequiredDocuments: any = createAction('exempReference/EXEMPTION_REFERENCE', (data: any[]) => () => {
  return data;
});
